import { request } from '@/utils/request'

// 获取公司简介
export function getWebsiteMilepostInfo(data) {
  return request({
    url: 'getWebsiteMilepostInfo',
    method: 'get',
    params: data
  })
}

// 获取领导团队
export function getWebsiteLeaderInfoList(data) {
  return request({
    url: 'getWebsiteLeaderInfoList',
    method: 'get',
    params: data
  })
}
